<script setup>
import { reactive, watch } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps({
  externalUrls: { type: Object },
  errors: { type: Object },
  windowInnerWidth: Number,
});
const emit = defineEmits(['inputValue']);
const data = reactive({ external_urls: {} });

const unwatch = watch(
  () => props.externalUrls,
  (propsExternalUrls) => {
    data.external_urls = propsExternalUrls;
    unwatch();
  }
);
function title(i) {
  if (i == 0) return i18n.global.t('pages.operationOffices.form.externalUrls.title');
  return '';
}
function startEdit() {
  data.external_urls.push({ name: '', url: '' });
}
watch(data, () => {
  emit('inputValue', data);
});
</script>
<template>
  <template v-if="false">
    <v-row
      class="text-form pl-4 pr-3 mb-3"
      v-for="(externalUrl, i) in data.external_urls"
      :key="i"
    >
      <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
        <h6 class="pl-4 align-center">{{ title(i) }}</h6>
      </v-col>
      <v-col :cols="windowInnerWidth > 800 ? 4 : 4.5">
        <v-text-field
          :label="`${i18n.global.t('pages.operationOffices.form.externalUrls.name')} ${'&nbsp;'} ${i18n.global.t('pages.operationOffices.form.externalUrls.nameSample')}`"
          v-model="data.external_urls[i].name"
          :error-messages="errors[`external_urls.${i}.name`]"
        />
      </v-col>
      <v-col :cols="windowInnerWidth > 800 ? 4 : 4.5">
        <v-text-field
          :label="`${i18n.global.t('pages.operationOffices.form.externalUrls.url')} ${'&nbsp;'} ${i18n.global.t('pages.operationOffices.form.externalUrls.urlSample')}`"
          v-model="data.external_urls[i].url"
          :error-messages="errors[`external_urls.${i}.url`]"
        />
      </v-col>
      <v-col cols="1" v-if="i == 0">
        <v-btn
          @click="startEdit(externalUrl)"
          class="ml-3"
          style="background-color: #dddddd; max-width: 30px"
        >
          +
        </v-btn>
      </v-col>
      <v-col cols="1" v-else />
    </v-row>
  </template>
</template>
